import { combineReducers, configureStore } from '@reduxjs/toolkit'
import { languageSideEffectsMiddleware } from './languageSideEffectsMiddleware'
import { loadingBarReducer } from 'react-redux-loading-bar'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

import authReducer from './reducers/AuthReducer'
import appReducer from './reducers/AppReducer'
import commonReducer from './reducers/CommonReducer'
import categoriesReducer from './reducers/CategoriesReducer'
import modalsReducer from './reducers/ModalsReducer'
import toasterReducer from './reducers/ToasterReducer'
import selectedProductsReducer from './reducers/SelectedProductsReducer'
import filtersReducer from './reducers/FiltersReducer'
import restaurantsReducer from './reducers/RestaurantsReducer'
import specialsReducer from './reducers/SpecialsReducer'
import wishlistSlice from './reducers/WishlistReducer'
import tableReservationReducer from './reducers/TableReservation'
// import cloudOrdersReducer from './reducers/CloudOrdersReducer'
import qrMenuTableReducer from './reducers/QRMenuTableReducer'
import qrMenuBucketReducer from './reducers/QRMenuBucketReducer'
import translationsReducer from './reducers/TranslationsReducer'

export const rootReducer = combineReducers({
  auth: authReducer,
  app: appReducer,
  common: commonReducer,
  categories: categoriesReducer,
  modals: modalsReducer,
  toasts: toasterReducer,
  selectedProducts: selectedProductsReducer,
  filters: filtersReducer,
  restaurants: restaurantsReducer,
  specials: specialsReducer,
  wishlist: wishlistSlice,
  loadingBar: loadingBarReducer,
  tableReservation: tableReservationReducer,
  // cloudOrders: cloudOrdersReducer,
  qrMenuTable: qrMenuTableReducer,
  bucket: qrMenuBucketReducer,
  translations: translationsReducer,
})

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['bucket', 'wishlist'],
  version: 1,
}
const persistedReducer = persistReducer(persistConfig, rootReducer)

export const setupStore = () => {
  return configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: false,
      }).concat(languageSideEffectsMiddleware),
  })
}

export const store = setupStore()
export const persistor = persistStore(store)

export type RootState = ReturnType<typeof rootReducer>
export type AppStore = ReturnType<typeof setupStore>
export type AppDispatch = AppStore['dispatch']
